import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Col, ConfigProvider, Divider, Modal, Row, Table, Tag, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { useEffect, useRef, useState } from "react";
import { useGetNotifications } from "../ServerSideStates";
import dayjs from "dayjs";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useQueryClient } from "react-query";
import endPoints from "../EndPoints";
import { deleteListNotification } from "../Services";
import useWindowSize from "helpers/useWindowSize";

const ListItems = () => {
  const containerRef = useRef(null);
  const windowSize = useWindowSize(containerRef);
  const [isDesktop, setIsDesktop] = useState(false);
  const { Text } = Typography;
  const queryClient = useQueryClient();
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const notifications = useGetNotifications();


  const confirmDeleteNotifications = (records: any[]) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu öğe silinecek. Onaylıyor musunuz?`,
      okText: "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          await deleteListNotification(records);
          openNotificationWithIcon("default", "İşlem Başarılı");
          queryClient.resetQueries({
            queryKey: endPoints.getNotificationList,
            exact: false,
          });
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  const columns = [
    {
      title: "Başlık",
      dataIndex: "subject",
      key: "subject",
      render: (value: string, record: any) => {
        return (
          
           <div className="!flex !flex-col gap-0 w-full px-4 xl:px-0">
  <div className="w-full">
    <Text className="!font-bold xl:!font-normal">{value}</Text>
  </div>
  <div className="!flex !flex-col gap-0 xl:!hidden w-full">
    <div className="w-full">
      <Text className="!text-xs md:!text-sm">{record?.message}</Text>
    </div>
    <div className="w-full">
      <Text className="!text-xs !text-gray-400">
        {dayjs(value).format("DD.MM.YYYY")}
      </Text>
    </div>
    <div className="w-full">
      <Tag className="!border-none !bg-transparent !p-0" color={value ? "green" : "error"}>
        {value ? "Okundu" : "Okunmamış"}
      </Tag>
    </div>
    <div className="w-full">
      <MazakaButton
        icon={<DeleteOutlined />}
        className="!text-red-500 !border-none !p-0 !flex gap-1 !text-xs md:!text-sm w-full justify-start"
        type="text"
        onClick={() => {
          confirmDeleteNotifications([record.id]);
        }}
      >
        Sil
      </MazakaButton>
    </div>
  </div>
</div>
            
       
        );
      },
    },
    ...(isDesktop?[

      {
        title: "Açıklama",
        dataIndex: "message",
        key: "message",
        render: (value: string) => {
          return <Text className="!hidden xl:!block">{value}</Text>;
        },
      },
      {
        title: "Tarih",
        dataIndex: "insertDate",
        key: "insertDate",
        render: (value: string) => (
          <Text className="!hidden xl:!block">
            {dayjs(value).format("DD.MM.YYYY")}
          </Text>
        ),
      },
      {
        title: "Okunma Durumu",
        dataIndex: "isRead",
  
        render: (value: string) => {
          return (
          
              <Tag
                className="!hidden xl:!inline"
                color={value ? "green" : "error"}
              >
                {value ? "Okundu" : "Okunmamış"}
              </Tag>
         
          );
        },
      },
      {
        title: "İşlem",
        key: "action",
        render: (_: any, record: any) => (
          <MazakaButton
            icon={<DeleteOutlined />}
            className="xl:hover:!bg-red-500 xl:hover:!text-white xl:!text-red-500 !bg-red-500 !h-[45px] !text-white xl:!bg-transparent !hidden xl:!block"
            type="text"
            onClick={() => {
              confirmDeleteNotifications([record.id]);
            }}
          >
            Sil
          </MazakaButton>
        ),
      },

    ]:[]),
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys: React.Key[]) => setSelectedRowKeys(keys as string[]),
  };
  useEffect(() => {
    if (windowSize.width > 1040) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  }, []);

  return (
    <Col xs={24}>
      <Row>
        {selectedRowKeys.length > 0 && (
          <>
            <Col
              xs={24}
              className="!bg-[#fafafa] !p-2 !flex gap-2 items-center "
            >
              <Text className="!font-bold !text-sm">
                {selectedRowKeys.length} oğe secildi
              </Text>
              <MazakaButton
                className="!bg-red-500 !text-white"
                icon={<DeleteOutlined />}
                onClick={() => {
                  confirmDeleteNotifications(selectedRowKeys);
                }}
              >
                Sil
              </MazakaButton>
            </Col>
          </>
        )}

        <Col xs={24}>
          <div className="!hidden xl:!block">
            <ConfigProvider
            >

            <Table
              rowSelection={isDesktop ? rowSelection : undefined}
              rowKey={"id"}
              columns={columns}
              rowClassName="responsive-row"
              dataSource={notifications.data?.data || []}
              pagination={false}
            />
            </ConfigProvider>
          </div>
          <div className="!block xl:!hidden">
            <Table
              rowKey={"id"}
              columns={columns}
              rowClassName="responsive-row"
              dataSource={notifications.data?.data || []}
              pagination={false}
            />
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default ListItems;
